import React from 'react';
import Text from '@text';
import ShowFormComponents from './show-form.components';
import { useParamsContext } from '../../../params/params-context';

interface ShowFormProps {
  showForm: () => void;
}

const { Header, Button, Container, BackgroundContainer } = ShowFormComponents;
const ShowForm: React.FunctionComponent<ShowFormProps> = ({ showForm }) => {
  const { portalType } = useParamsContext();
  return (
    <BackgroundContainer>
      <Container>
        <Header
          tParams={{
            tKey: [
              `form.${portalType}.didntFindQuestion`,
              'form.didntFindQuestion'
            ]
          }}
        />
        <Button onClick={showForm}>
          <Text tParams="form.contactUs" />
        </Button>
      </Container>
    </BackgroundContainer>
  );
};

export default ShowForm;
